import React, { useContext, useEffect, useRef, useState } from 'react'
import FormCreator from '../../../components/forms/FormCreator';
import { BoardcommitteeApprovalFormData } from '../data/BoardCommitteeApprovalForm.Data';
import { useParams } from 'react-router-dom';
import { useSendBoardCommitteeApprovalMutation, useSubmitBoardCommitteeApprovalMutation } from '../../../app/services/BoardCommitteeApproval/BoardCommitteeServiceApi';
import { decryptAESID } from '../../../utils/Encryption';
import SwalAlert from '../../../services/swalService/SwalService';
import MembershipTaskListContext from '../MembershipTaskListContextProvider';
import { setBoardCommitteeInitials } from '../utils/EditTaskListSetFormFields';
import CenterModel from '../../../components/ui/centerModel/CenterModel';
import DataLoader from '../../../components/FinalMolGrid/ui/dataLoader/DataLoader';
import { ApplicationStatus } from '../../../utils/Constants';
import { getAuditContext } from '../../../lib/authenticationLibrary';

const BoardcommitteeApprovalForm = () => {
    const admissionCommitteRef = useRef();
    const [boardCommitteForm, setBoardCommitteFormForm] = useState(BoardcommitteeApprovalFormData);
    const params = useParams();
    const { success, confirm, error } = SwalAlert();
    const audit = getAuditContext();
    const { taskListDetailsData, fetchTaskListDetails, fetchBoardCommitteeList } = useContext(MembershipTaskListContext);
    const [snedForApprovalModelOpen, setSnedForApprovalModelOpen] = useState(false)

    const [sendBoardCommitteeApproval, {
        isLoading: sendBoardCommitteeApprovalIsLoading,
        data: sendBoardCommitteeApprovalData,
        isSuccess: sendBoardCommitteeApprovalSuccess
    }] = useSendBoardCommitteeApprovalMutation();

    useEffect(() => {
        if (!sendBoardCommitteeApprovalIsLoading && sendBoardCommitteeApprovalData && sendBoardCommitteeApprovalSuccess) {
            openModal();
            success("Application is send successfully", "Success")
            let request = {
                ipasMemberId: Number(decryptAESID(params.memberId)),
                taskListId: Number(decryptAESID(params.taskListId)),
            }
            fetchTaskListDetails(request);
            fetchBoardCommitteeList(request)
        }
    }, [sendBoardCommitteeApprovalIsLoading, sendBoardCommitteeApprovalData, sendBoardCommitteeApprovalSuccess]);

    const [submitBoardCommitteeApproval, {
        isLoading: submitBoardCommitteeApprovalIsLoading,
        data: submitBoardCommitteeApprovalData,
        isSuccess: submitBoardCommitteeApprovalSuccess
    }] = useSubmitBoardCommitteeApprovalMutation();

    useEffect(() => {
        if (taskListDetailsData) {
            const updatedForm = setBoardCommitteeInitials(taskListDetailsData, boardCommitteForm)
            setBoardCommitteFormForm({ ...updatedForm });
        }
    }, [taskListDetailsData]);

    useEffect(() => {
        if (!submitBoardCommitteeApprovalIsLoading && submitBoardCommitteeApprovalData && submitBoardCommitteeApprovalSuccess) {
            success("Application is submitted successfully.", "Success")
            let request = {
                ipasMemberId: Number(decryptAESID(params.memberId)),
                taskListId: Number(decryptAESID(params.taskListId)),
            }
            fetchTaskListDetails(request);
        }
    }, [submitBoardCommitteeApprovalIsLoading, submitBoardCommitteeApprovalData, submitBoardCommitteeApprovalSuccess]);

    useEffect(() => {
        if (taskListDetailsData && fetchTaskListDetails) {
            setBoardCommitteFormForm(prevForm => {
                if (!prevForm || !prevForm.section) return prevForm;

                const updatedConfig = {
                    ...prevForm,
                    section: prevForm.section.map(section => ({
                        ...section,
                        fields: section.fields.map(fields => {
                            if (fields?.fieldSetting?.formControltemplate?.props?.actionName === "SEND_FOR_APPROVAL") {
                                const shouldDisable = taskListDetailsData?.applicationStatusId === 10;
                                return {
                                    ...fields,
                                    fieldSetting: {
                                        ...fields.fieldSetting,
                                        isTemplateBtnDisable: shouldDisable,
                                    },
                                };
                            }
                            return fields;
                        }),
                    })),
                };

                return updatedConfig;
            });
        }
    }, [taskListDetailsData, fetchTaskListDetails])

    const handleActionChange = (action, data, formData) => {
        const { applicationStatusId, isAdmissionBoardSubmittedByAdmin, isBoardCommitteeSubmittedByAdmin } = taskListDetailsData;
        debugger
        if (isBoardCommitteeSubmittedByAdmin && applicationStatusId != ApplicationStatus.ClarificationSubmitted) {
            return; // if alrady submitted then not allow
        }
        else if (applicationStatusId === ApplicationStatus.SendClarification) {
            return error("Clarification is not submitted yet.", "Validation Error")
        }
        else if (taskListDetailsData?.applicationStatusId === 10) {
            return;
        }
        else if (!isAdmissionBoardSubmittedByAdmin) {
            return error("Pending Admission Committee Approval.", "Validation Error")
        }
        else if (action === "SEND_FOR_APPROVAL") {
            if (taskListDetailsData?.applicationStatusId === 10) {
                return;
            }
            else if (applicationStatusId === ApplicationStatus.PendingBoardApproval) {
                return error("Applications already send for approval.", "Validation Error")
            }
            else if (formData) {
                if (!formData.comments || formData.comments.trim() === "" || !formData.deadline || String(formData.deadline).trim() === "") {
                    error("Please enter required fields.", "Validation Error");
                    return;
                }
                openModal();
                let request = {
                    ApplicationTaskListId: Number(decryptAESID(params.taskListId)),
                    IPASMemberId: Number(decryptAESID(params.memberId)),
                    BoardCommitteeSecretariatSummary: formData.comments,
                    BoardCommitteeDeadline: formData.deadline,
                    CreatedBy: audit.adminUserId,
                    CreatedAppId: audit.appId
                }
                sendBoardCommitteeApproval(request)
            }
        }
        else if (action === "SUBMIT") {
            if (taskListDetailsData?.applicationStatusId === 10) {
                return;
            }
            else if (applicationStatusId !== ApplicationStatus.PendingBoardApproval && applicationStatusId !== ApplicationStatus.ClarificationSubmitted) {
                return error("Pending send application for Board of Directors.", "Validation Error")
            }
            else if (formData) {
                if (!formData.additionalNotes || formData.additionalNotes.trim() === "" || !formData.boardApprovalDate || String(formData.boardApprovalDate).trim() === "") {
                    error("Please enter required fields.", "Validation Error");
                    return;
                }

                let request = {
                    ApplicationTaskListId: Number(decryptAESID(params.taskListId)),
                    IPASMemberId: Number(decryptAESID(params.memberId)),
                    AdditionalNotes: formData.additionalNotes,
                    BoardCommitteeBoardApprovalDate: formData.boardApprovalDate,
                    CreatedBy: audit.adminUserId,
                    CreatedAppId: audit.appId
                }
                submitBoardCommitteeApproval(request);
            }
        }
    }

    const openModal = () => {
        setSnedForApprovalModelOpen(!snedForApprovalModelOpen);
    }

    return (
        <div className='col-12'>
            <FormCreator
                config={boardCommitteForm}
                ref={admissionCommitteRef}
                key={false}
                onActionChange={handleActionChange}

            />
            {snedForApprovalModelOpen && <CenterModel
                modelTitle={'Sending application for approval.'}
                show={"test"}
                className="custom-modal-50"
            //handleClose={openModal}
            //onUpload={openModal}
            >
                <DataLoader />
                {/* <Buttons
                    buttonText="Reject Application"
                    buttonTypeClassName="theme-btn btn mt-5"
                 isLoading={rejectMemberApplicationIsLoading}
                 onClick={handleReject}
                /> */}
            </CenterModel>
            }
        </div>
    )
}

export default BoardcommitteeApprovalForm